import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/vercel/path0/apps/web-bookis/src/components/Providers.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/react-loading-skeleton/dist/skeleton.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/swiper/swiper.min.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/swiper/modules/pagination/pagination.min.css");
